import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaSignOutAlt } from 'react-icons/fa'; // Import logout icon from react-icons
import { format } from 'date-fns'; // Import date-fns for date formatting

const TopNavbar = () => {
    const [currentDateTime, setCurrentDateTime] = useState('');
    const [user, setUser] = useState({ name: '', lastname: '' });

    useEffect(() => {
        // Fetch user information from localStorage or an API if you have it stored there
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
            setUser(storedUser); // Update user state with stored user info
        }

        // Function to update current time and date
        const updateDateTime = () => {
            const now = new Date();
            const formattedDateTime = format(now, 'dd.MM.yyyy HH:mm'); // Format the current date and time
            setCurrentDateTime(formattedDateTime);
        };

        // Set the initial time
        updateDateTime();

        // Update the time every minute
        const intervalId = setInterval(updateDateTime, 60000); // Update every 60 seconds (1 minute)

        return () => clearInterval(intervalId); // Cleanup the interval on component unmount
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/login';
    };

    return (
        <nav className="navbar navbar-light bg-light justify-content-between px-3">
            {/* Display the logged-in user information */}
            <div>
                <span className="me-3 fw-bold text-primary">
                    {user.name} {user.lastname}
                </span>
                {/* Display the current date and time */}
                <span className="text-primary fw-bold">Date: {currentDateTime}</span>
            </div>

            {/* Logout icon button */}
            <div>
                <button
                    className="btn btn-outline-default"
                    onClick={handleLogout}
                >
                    <FaSignOutAlt className={"text-primary"}/>
                </button>
            </div>
        </nav>
    );
};

export default TopNavbar;
